import React, { useRef } from 'react';
import { arrayMoveImmutable } from 'array-move';

const DragWrapper = ({ children, className, dataList, sortUpdate, id, style }) => {
  const currentNode = useRef(null);
  const dragStart = (e) => {
    currentNode.current = e.target;
    setTimeout(() => {
      currentNode.current.classList.add('moving');
    });
    e.dataTransfer.effectAllowed = 'move';
  };
  const dragEnter = (e) => {
    if (!currentNode.current?.dataset) return;
    e.preventDefault();
    const newIndex = +e.target.dataset.num;
    const oldIndex = +currentNode.current.dataset.num;
    const newSorts = arrayMoveImmutable(dataList, oldIndex, newIndex);
    sortUpdate(newSorts);
  };
  const dragOver = (e) => {
    e.preventDefault();
  };
  const dragEnd = () => {
    currentNode.current.classList.remove('moving');
  };
  return (
    <div
      className={className}
      style={style}
      onDragStart={(e) => dragStart(e)}
      onDragEnter={(e) => dragEnter(e)}
      onDragOver={(e) => dragOver(e)}
      onDragEnd={(e) => dragEnd(e)}
    >
      {/* 滚动定位楔子 */}
      <i id={id} />
      {children}
    </div>
  );
};

export default DragWrapper;
